import React from "react";
import { ArrowRight, Palette } from "lucide-react";

export default function DesignServiceSection() {
  return (
    <section className="bg-[color:var(--dms-navy)] py-24">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Design service</p>
        <div className="w-16 h-16 rounded-full bg-[color:var(--dms-peach)] mx-auto mt-6 flex items-center justify-center">
          <Palette className="w-7 h-7 text-[color:var(--dms-navy)]" />
        </div>
        <h2 className="font-serif text-3xl md:text-5xl text-white mt-6 leading-tight">
          Have an idea but don't know how to design it?<br /> We'll create it for you.
        </h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-6" />
        <p className="mt-6 text-white/75">Tell us your idea and we'll turn it into a custom T-shirt design.</p>
        <p className="mt-4 text-white/60 text-sm"><strong className="text-white">Design fee applies.</strong> Our design service is an additional fee, quoted with your proof. You approve the design and the price before anything is printed.</p>
        <div className="mt-8">
          <a href="#custom" className="btn-peach">Start my custom design <ArrowRight className="w-4 h-4" /></a>
        </div>
      </div>
    </section>
  );
}
